module.exports = __webpack_public_path__ + "img/map-distance.c3e152fc.svg";